import React from "react";
import {InfiosLoadingEllipsis} from "./LoadingEllipsis.style";

const LoadingEllipsis = (props) => {

    return (
        <InfiosLoadingEllipsis>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </InfiosLoadingEllipsis>
    )
}

export default LoadingEllipsis;
